export default {
  SET_EMPRESAS(state, payload) {
    state.empresas = payload;
  },
  SET_USUARIOS_RESPONSAVEIS_COMEX(state, payload) {
    state.responsaveisComex = payload.map(({ id, nome, foto, email, cargo, slugCargo }) => ({
      id, nome, foto, Email: email, cargo, slugCargo,
    }));
  },
  SET_EMPRESA_DNA(state, payload) {
    state.empresaDNA = payload;
  },
  SET_USUARIOS_RESPONSAVEIS_EXECUTIVOS(state, payload) {
    state.responsaveisExecutivos = payload.map(({ id, nome, foto, Email }) => ({
      id, nome, foto, Email, cargo: 'Executivo', slugCargo: 'EXECUTIVO',
    }));
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
